import {Outlet} from "react-router-dom";

import {Header} from "./header/Header";
import {Footer} from "./footer/Footer";

export const GuestLayout = () => {
    return (
        <div className="guest">
            <Header/>
            <Outlet/>
            <Footer/>
        </div>
    );
};
